import React, { useContext } from 'react';
import { Col, Row } from '@thd-olt-component-react/grid';
import { Accordion, AccordionBody, AccordionTitle, Button } from '@thd-olt-component-react/core-ui';
import { ComponentPlaceholder } from '@thd-olt-component-react/loading-placeholder';
import { Header } from './component/Header';
import { Pager } from '../Pager/Pager.component';
import { PagerDisplayText } from '../PagerDisplayText/PagerDisplayText.component';
import { Sort } from '../Filter';
import { QuestionContainer } from './component/QuestionContainer';
import { AnswerContainer } from './component/AnswerContainer';
import { triggerAnalytics } from '../../Analytics';
import { NoContent } from '../NoContent/NoContent.component';
import QAContext from '../../context/QAContext';
import { useQAResult } from './useQAResult';
import { useSEO } from './useSEO';
import { dataModel } from '../dataModel';
import './QAResult.scss';

const QAResultDesktop = () => {
  let {
    qaLoading, dispatch, seoPageNumber, searchText, Results, TotalResults
  } = useContext(QAContext);

  const qaResult = useQAResult();
  const {
    seoResults, seoAnswers, seoTotalResults, seoPrevPage, seoNextPage
  } = useSEO(qaResult);
  if (seoPageNumber && seoResults) {
    Results = seoResults;
  }

  const isSeoPage = !!(seoPageNumber && qaResult);
  const showResults = !!(Results?.length || searchText);

  if (qaLoading) {
    return <ComponentPlaceholder height={125} rows={4} color="#E0E0E0" showLoadingAnimation />;
  }

  const analyticsReadQuestion = () => {
    const payload = { component: 'read question' };
    triggerAnalytics(payload);
  };

  const handleClearSearchPill = () => {
    dispatch({ action: 'SET_SEARCH_TEXT', value: '' });
  };

  return (
    <>
      {!showResults && <NoContent />}

      {showResults
        && (
          <div className="qa-result">
            <Row>
              <Col>
                <Header showTitleWithTotalQns seoData={seoTotalResults} />
              </Col>

              {!qaResult && (
                <div className="qa-result__title">
                  <PagerDisplayText topPager loading={qaLoading} />
                  {searchText && (
                    <Button className="search-pill" onClick={handleClearSearchPill} filter>
                      {Results?.length ? searchText : 'Clear search term'}
                    </Button>
                  )}
                  <Sort />
                </div>
              )}

              <Col className="qa-result__questions" aria-label="questions" nopadding>
                {Results?.length > 0
                && Results.map((result) => {
                  const { Id } = result;

                  return (
                    <Accordion
                      icon={{ size: 'sm' }}
                      iconPosition="right"
                      onChange={analyticsReadQuestion}
                      key={Id}
                      expanded={isSeoPage}
                    >
                      <AccordionTitle>
                        <QuestionContainer result={result} />
                      </AccordionTitle>
                      <AccordionBody>
                        <AnswerContainer result={result} seoData={seoAnswers} />
                      </AccordionBody>
                    </Accordion>
                  );
                })}
              </Col>
            </Row>
            {Results?.length && !qaResult ? (
              <Row>
                <Col fallback="12" className="pager-section">
                  {TotalResults > 4 && (
                    <div className="q-a__review-pager">
                      <Pager />
                    </div>
                  )}
                  <Row className="q-a__review-pager__summary">
                    <PagerDisplayText topPager={false} loading={qaLoading} />
                  </Row>
                </Col>
              </Row>
            ) : (
              <></>
            )}
            {qaResult && (
              <Row>
                <Col>
                  {seoPrevPage > -1 && (<a href={`${seoPrevPage}`}>{`page ${seoPrevPage}`}</a>)}
                  {' '}
                  {seoNextPage > -1 && (<a href={`${seoNextPage}`}>{`page ${seoNextPage}`}</a>)}
                </Col>
              </Row>
            )}
          </div>
        )}
    </>
  );
};

QAResultDesktop.displayName = 'QAResultDesktop';

QAResultDesktop.dataModel = dataModel;

export { QAResultDesktop };
